var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return this.$route.path == '/view-group-quote' ? _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(0), _c('tbody', [_c('tr', [!_vm.groupLength ? _c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v(" No records found. ")]) : _vm._e()]), _vm._l(_vm.groupCensusList.records, function (employee, index) {
    return _c('tr', {
      key: index,
      class: "group-status-".concat(employee.approval_status.toLowerCase())
    }, [_c('td', {
      staticClass: "text-capitalize"
    }, [_c('b', [_vm._v("Group Name:")]), _vm._v(" " + _vm._s(employee.group_name) + " "), _c('br'), _c('b', [_vm._v("Contact Name: ")]), _vm._v(" " + _vm._s(employee.group_contact_name)), _c('br'), _c('b', [_vm._v("Contact Phone: ")]), _vm._v(" " + _vm._s(_vm._f("us_phone")(employee.group_contact_phone))), _c('br'), _c('b', [_vm._v("Contact Email:")]), _vm._v(" " + _vm._s(employee.group_contact_email)), _c('br')]), _c('td', {
      staticClass: "text-capitalize"
    }, [_c('b', [_vm._v("Group Address:")]), _vm._v(" " + _vm._s(employee.group_address)), _c('br'), _c('b', [_vm._v("Group Start Date: ")]), _vm._v(_vm._s(employee.group_requested_start_date)), _c('br'), _vm._m(1, true), _vm._v(" " + _vm._s(employee.primary_count)), _c('br'), _vm._m(2, true), _vm._v(" " + _vm._s(employee.dependent_count)), _c('br'), _c('b', [_vm._v("Group Industry:")]), _vm._v(" " + _vm._s(employee.group_industry_title)), _c('br'), _c('span', {
      staticClass: "badge group-quote-badge",
      class: "group-status-".concat(employee.is_group_registered === 1 ? 'registered' : 'unregistered')
    }, [_vm._v(" " + _vm._s(employee.is_group_registered === 1 ? 'Registered' : 'Unregistered') + " ")])]), _c('td', {
      staticStyle: {
        "width": "15%"
      }
    }, _vm._l(employee.group_plans, function (plans, index) {
      return _c('ul', {
        key: index,
        staticClass: "d-flex align-items-center "
      }, [_c('li', [_vm._v(_vm._s(plans.plan_name))])]);
    }), 0), _c('td', {
      class: "status-".concat(employee.approval_status.toLowerCase())
    }, [_vm._v(" " + _vm._s(employee.approval_status) + " ")]), _c('td', [_c('custom-button', {
      staticClass: "group-action-icons",
      attrs: {
        "title": "View Group Quote",
        "iconClass": "fas fa-user-friends"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.openGroupDetailModel(employee);
        }
      }
    }), _c('custom-button', {
      staticClass: "group-action-icons",
      attrs: {
        "title": "Download Group Quote",
        "iconClass": "fas fa-download"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.downloadGroupXls(employee);
        }
      }
    }), _vm.checkGroupForRegistration(employee) && !employee.is_group_registered ? _c('custom-button', {
      staticClass: "group-action-icons",
      attrs: {
        "title": "Group Registration",
        "iconClass": "fas fa-link"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.routeToGroupRegistration(employee);
        }
      }
    }) : _vm._e(), employee.approval_status === 'APPROVED' && employee.approved_file_url ? _c('custom-button', {
      staticClass: "group-action-icons",
      attrs: {
        "title": "Download Group Quote Approved File",
        "iconClass": "fas fa-file-pdf"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.downloadApprovedFiles(employee);
        }
      }
    }) : _vm._e()], 1)]);
  }), _vm.groupCensusList.length < 0 ? _c('tr', [_c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v("No records found.")])]) : _vm._e()], 2)]), _c('div', [_c('group-detail-model', {
    attrs: {
      "employeeInfo": _vm.employeeInfo
    }
  })], 1)]) : _c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table"
  }, [_vm._m(3), _c('tbody', [_c('tr', [!_vm.groupLength ? _c('td', {
    attrs: {
      "colspan": "7",
      "align": "center"
    }
  }, [_vm._v(" No records found. ")]) : _vm._e()]), _vm._l(_vm.groupCensusList.records, function (employee, index) {
    return _c('tr', {
      key: index,
      class: "group-status-".concat(employee.approval_status.toLowerCase())
    }, [_c('td', [_c('b', [_vm._v("Group Name: ")]), _c('span', {
      staticClass: "text-capitalize"
    }, [_vm._v(_vm._s(employee.group_name))]), _c('br'), _c('b', [_vm._v("Contact Name: ")]), _c('span', {
      staticClass: "text-capitalize"
    }, [_vm._v(" " + _vm._s(employee.group_contact_name) + " ")]), _c('br'), _c('b', [_vm._v("Contact Phone:")]), _vm._v(" " + _vm._s(_vm._f("us_phone")(employee.group_contact_phone))), _c('br'), _c('b', [_vm._v("Contact Email:")]), _vm._v(" " + _vm._s(employee.group_contact_email)), _c('br')]), _c('td', [employee.group_census_report.length > 0 ? _c('div', {
      staticClass: "member-list  member-scrollable-content"
    }, _vm._l(employee.group_census_report, function (member, index) {
      return _c('div', {
        key: index,
        staticClass: "quote-member-card"
      }, [_c('p', [_c('span', [_vm._v(" " + _vm._s(member.first_name + " " + member.last_name) + " - "), _c('span', {
        staticClass: "member-plan-type"
      }, [_vm._v(" " + _vm._s(member.plan_type))])]), _c('span', {
        staticClass: "member-edit-btns"
      }, [employee.is_quote_clcked != 1 ? _c('div', {
        staticClass: "group-action-icons",
        attrs: {
          "title": "Delete Member"
        }
      }, [_c('i', {
        staticClass: "fa-solid fa-trash",
        on: {
          "click": function click($event) {
            return _vm.openDeleteMemberModal(member.id);
          }
        }
      })]) : _vm._e()])]), member.plan_details && member.plan_details.length > 0 ? _c('ul', {
        staticClass: "pt-3"
      }, _vm._l(member.plan_details, function (plan, index) {
        return _c('li', {
          key: index
        }, [_c('p', [_c('span', {
          staticClass: "member-plan-name",
          attrs: {
            "title": plan === null || plan === void 0 ? void 0 : plan.plan_name
          }
        }, [_vm._v(_vm._s(plan === null || plan === void 0 ? void 0 : plan.plan_name))]), _vm._v(" "), _c('span', [_vm._v(" $" + _vm._s(plan === null || plan === void 0 ? void 0 : plan.plan_price) + " ")])])]);
      }), 0) : _vm._e()]);
    }), 0) : _vm._e()]), _c('td', [_c('div', [_c('p', {
      staticClass: "mb-0 fw-bolder"
    }, [_vm._v("Quote Created Date: ")]), _c('p', [_vm._v(_vm._s(employee.created_at ? _vm.handleDateFormat(employee.created_at) : "N/A"))])]), _c('div', [_c('p', {
      staticClass: "mb-0 fw-bolder"
    }, [_vm._v("Quote Sent Date: ")]), _c('p', [_vm._v(_vm._s(employee.sent_date ? _vm.handleDateFormat(employee.sent_date) : "N/A"))])])]), _c('td', [_vm._v(" " + _vm._s(employee.group_quote_total && "$".concat(employee.group_quote_total)) + " ")]), _c('td', {
      class: "status-".concat(_vm.groupQuoteStatusClass(_vm.groupQuoteStatusMessage(employee.is_quote_clcked, employee.is_group_registered)))
    }, [_vm._v(" " + _vm._s(_vm.groupQuoteStatusMessage(employee.is_quote_clcked, employee.is_group_registered)) + " ")]), _c('td', {
      staticClass: "ps-0"
    }, [_c('custom-button', {
      staticClass: "group-action-icons",
      attrs: {
        "title": "View Group Quote",
        "iconClass": "fas fa-user-friends"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.openGroupDetailModel(employee);
        }
      }
    }), employee.is_quote_clcked != 1 ? _c('custom-button', {
      staticClass: "group-action-icons",
      attrs: {
        "title": "Add Member",
        "iconClass": "fas fa-plus"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.renderAddQuoteMemberModal(employee.id, employee.platform_name, 'add');
        }
      }
    }) : _vm._e(), _vm.hasMembersAndPlans(employee) && employee.is_quote_clcked != 1 && employee.status == 1 ? _c('custom-button', {
      staticClass: "group-action-icons",
      attrs: {
        "title": "Send Quote",
        "iconClass": "fas fa-paper-plane"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.renderSendQuoteConfirmationModal(employee.id);
        }
      }
    }) : _vm._e(), _c('custom-button', {
      directives: [{
        name: "b-modal",
        rawName: "v-b-modal.quoteDeleteModal",
        modifiers: {
          "quoteDeleteModal": true
        }
      }],
      staticClass: "group-action-icons icon-delete-bg",
      attrs: {
        "title": "Delete Quote",
        "iconClass": "fas fa-trash"
      },
      on: {
        "onClicked": function onClicked($event) {
          return _vm.setSelectedQuote(employee.id);
        }
      }
    })], 1)]);
  })], 2)]), _c('div', [_c('group-detail-model', {
    attrs: {
      "employeeInfo": _vm.employeeInfo
    }
  }), _c('delete-group-member', {
    attrs: {
      "id": _vm.currentMemberId
    }
  })], 1), _c('add-group-quote-member', {
    attrs: {
      "groupCensusId": _vm.currentGroupCensusId,
      "currentGroupPlatform": _vm.currentEnrollmentPlatform,
      "actionType": _vm.memberAction,
      "memberToBeUpdated": _vm.memberDetails
    }
  }), _c('send-quote-confirmation', {
    attrs: {
      "groupCensusId": _vm.currentGroupCensusId
    }
  }), _c('quote-delete-modal', {
    on: {
      "deleteQuote": function deleteQuote($event) {
        return _vm.confirmDelete();
      },
      "closeDeleteModal": function closeDeleteModal($event) {
        return _vm.clearSelectedQuote();
      }
    }
  })], 1);
}
var staticRenderFns = [function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Contact")]), _c('th', [_vm._v("Group Details")]), _c('th', [_vm._v("Group Plans")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Action")])])]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b', [_vm._v("Number of Primary Applicant"), _c('span', {
    staticStyle: {
      "text-transform": "lowercase"
    }
  }, [_vm._v("(s)")]), _vm._v(":")]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('b', [_vm._v("Number of Dependent"), _c('span', {
    staticStyle: {
      "text-transform": "lowercase"
    }
  }, [_vm._v("(s)")]), _vm._v(":")]);
},function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('thead', [_c('tr', [_c('th', [_vm._v("Group Details")]), _c('th', [_vm._v("Group Plans")]), _c('th', [_vm._v("Date")]), _c('th', [_vm._v("Group Quote Total")]), _c('th', [_vm._v("Status")]), _c('th', [_vm._v("Action")])])]);
}]

export { render, staticRenderFns }